import { useReactFlow } from '@xyflow/react';
import type { NodeSettingsProps } from '../../types';
import { useFlowDisplayLanguage } from '../../displayLanguage';

const labels = {
  choice1: { en: 'choice 1', ja: '候補1' },
  choice2: { en: 'choice 2', ja: '候補2' },
  choice3: { en: 'choice 3', ja: '候補3' },
} as const;

const defaults = {
  choice1: 'A',
  choice2: 'B',
  choice3: 'C',
} as const;

export function RandomChoiceSettings({ node }: NodeSettingsProps<'randomChoice'>) {
  const { updateNodeData } = useReactFlow();
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <div className="space-y-4">
      {(Object.keys(labels) as Array<keyof typeof labels>).map((field, index) => (
        <label key={field} className="block" data-product-tour={`card-input-${index + 1}`}>
          <span className="mb-1 block text-sm font-medium text-slate-700">
            {labels[field][displayLanguage]}
          </span>
          <input
            type="text"
            maxLength={200}
            value={typeof node.data[field] === 'string' ? node.data[field] : defaults[field]}
            onChange={(event) => updateNodeData(node.id, { [field]: event.target.value })}
            className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-red-400"
          />
        </label>
      ))}
    </div>
  );
}
